import React, { useEffect, useState } from 'react';
import { Check, X, ShieldCheck, Truck, Clock, AlertCircle, Star } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { TestimonialCard } from '../components/TestimonialCard';
import { FAQItem } from '../components/FAQItem';
import { ImagePlaceholder } from '../components/ImagePlaceholder';
import { StickyCTA } from '../components/StickyCTA';
export function AdvertorialPage() {
  const [showStickyCTA, setShowStickyCTA] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setShowStickyCTA(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToOffer = () => {
    window.location.href = 'https://www.tryglisera.com/pages/glisera-barrier-recovery';
  };
  return <div className="min-h-screen bg-white text-slate-900 font-sans selection:bg-rose-100 selection:text-rose-900" data-id="element-57">
      {/* Navigation / Header Bar */}
      <header className="border-b border-slate-200 bg-white sticky top-0 z-40" data-id="element-58">
        <div className="max-w-7xl mx-auto px-4 h-14 flex items-center justify-between" data-id="element-59">
          <div className="font-bold text-xl tracking-tight text-slate-900" data-id="element-60">
            Beauty & Wellness<span className="text-rose-600" data-id="element-61"> Insider</span>
          </div>
          <div className="text-xs font-medium text-slate-500 uppercase tracking-wider border border-slate-200 px-2 py-1 rounded" data-id="element-62">
            Advertorial
          </div>
        </div>
      </header>

      {/* Main Content with Sidebar Layout */}
      <div className="max-w-7xl mx-auto px-4 py-8 md:py-12" data-id="element-63">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_320px] gap-8" data-id="element-64">
          {/* Main Article Content */}
          <main data-id="element-65">
            {/* Article Meta */}
            <div className="mb-8 border-b border-slate-200 pb-8" data-id="element-66">
              <div className="flex items-center gap-2 text-sm text-slate-500 mb-4" data-id="element-67">
                <span className="font-bold text-rose-700 uppercase tracking-wide text-xs" data-id="element-68">
                  Health & Beauty
                </span>
                <span data-id="element-69">•</span>
                <span data-id="element-70">January 12, 2025</span>
                <span data-id="element-71">•</span>
                <span data-id="element-72">8,234 views</span>
              </div>

              <h1 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-slate-900 leading-tight mb-6 tracking-tight" data-id="element-73">
                Why Every "Hypoallergenic" Product You've Tried Has Made Your
                Skin MORE Reactive
              </h1>

              <div className="flex items-center gap-3" data-id="element-74">
                <div className="w-10 h-10 rounded-full bg-slate-200 flex items-center justify-center overflow-hidden" data-id="element-75">
                  <img src="https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=100&h=100" alt="Sarah Mitchell" className="w-full h-full object-cover" data-id="element-76" />
                </div>
                <div data-id="element-77">
                  <div className="font-bold text-slate-900 text-sm" data-id="element-78">
                    By Sarah Mitchell
                  </div>
                  <div className="text-slate-500 text-xs" data-id="element-79">
                    Skin Health Editor
                  </div>
                </div>
              </div>
            </div>

            {/* Article Body */}
            <article className="prose prose-lg prose-slate max-w-none font-serif" data-id="element-80">
              <p className="lead text-xl md:text-2xl text-slate-700 leading-relaxed font-medium mb-8" data-id="element-81">
                If your face burns when you use "gentle" skincare, you're not
                crazy.
              </p>

              <p data-id="element-82">And it's not your skin that's broken.</p>

              <p data-id="element-83">
                New research shows the real problem is something most brands
                don't want you to know.
              </p>

              <h2 className="font-sans font-bold text-2xl md:text-3xl text-slate-900 mt-12 mb-6" data-id="element-84">
                You've Tried Everything. And Everything Made It Worse.
              </h2>

              <p data-id="element-85">
                You've tried CeraVe. Vanicream. Cetaphil. All the "dermatologist
                recommended" brands.
              </p>

              <p data-id="element-86">
                Every single one promised "gentle" or "sensitive skin safe."
              </p>

              <p data-id="element-87">And every single one made things worse.</p>

              <img src="https://cdn.magicpatterns.com/uploads/9EsRmWfY5tDbQqmxmHFuKk/ChatGPT_Image_28_Ιαν_2026,_04_04_05_μ.μ..png" alt="Frustrated woman looking at multiple skincare products on bathroom counter" className="w-full rounded-xl my-8 shadow-lg" data-id="element-88" />

              <p data-id="element-89">
                First came the burning. Then the stinging. Then the redness that
                wouldn't go away.
              </p>

              <p data-id="element-90">
                You switched products. You simplified your routine. You spent
                more money on "cleaner" brands.
              </p>

              <p data-id="element-91">Nothing helped.</p>

              <p data-id="element-92">Some days, even water feels like acid on your face.</p>

              <p data-id="element-93">
                You dread looking in the mirror. You cancel plans when your skin
                flares up. You've stopped trusting any product that promises
                relief.
              </p>

              <p data-id="element-94">And the worst part?</p>

              <p data-id="element-95">
                You've spent hundreds—maybe thousands—on products that were
                supposed to help.
              </p>

              <p data-id="element-96">
                You're still stuck. Still burning. Still wondering what's wrong
                with you.
              </p>

              <p className="font-bold text-slate-900" data-id="element-97">
                Here's the truth: Nothing is wrong with you.
              </p>

              <p data-id="element-98">The problem is what's IN those products.</p>

              <h2 className="font-sans font-bold text-2xl md:text-3xl text-slate-900 mt-12 mb-6" data-id="element-99">
                Here's What No One Told You About Why Your Skin Reacts to
                Everything
              </h2>

              <p data-id="element-100">It's not that your skin is "too sensitive."</p>

              <p data-id="element-101">
                It's that your skin is doing exactly what it's supposed to do.
              </p>

              <p data-id="element-102">Let me explain.</p>

              <p data-id="element-103">
                Your skin has its own immune system. It's designed to protect
                you from threats. When something foreign touches your skin, your
                body decides: Is this safe? Or is this an invader?
              </p>

              <p data-id="element-104">Here's the problem.</p>

              <p data-id="element-105">
                Modern moisturizers are made from plants and petroleum. Seed
                oils. Synthetic chemicals. Lab-made emulsifiers.
              </p>

              <p data-id="element-106">Your skin has never seen these things before.</p>

              <img src="https://cdn.magicpatterns.com/uploads/3rfPJy2xtNdkTw2tFCPVLF/ChatGPT_Image_28_Ιαν_2026,_04_04_06_μ.μ..png" alt="Scientific diagram showing skin's immune response to foreign substances" className="w-full rounded-xl my-8 shadow-lg" data-id="element-107" />

              <p data-id="element-108">
                For 200,000 years, human skin evolved to recognize certain fats
                as "safe." These are the fats your body makes naturally.
              </p>

              <p data-id="element-109">
                Plant oils? Petroleum? Your skin sees them as foreign invaders.
                Threats. Enemies.
              </p>

              <p data-id="element-110">So it attacks.</p>

              <p data-id="element-111">
                That burning sensation when you apply a "gentle" lotion? That's
                your skin's immune system saying: "Get this OFF me."
              </p>

              <p data-id="element-112">And here's where it gets worse.</p>

              <p data-id="element-113">
                Each time you tried a new product and it burned, your skin got
                more defensive. More reactive. More scared of everything.
              </p>

              <p data-id="element-114">
                It's like your skin is now on high alert all the time. Ready to
                attack anything that touches it.
              </p>

              <div className="bg-rose-50 border-l-4 border-rose-500 p-6 my-8 not-prose rounded-r-lg" data-id="element-115">
                <p className="font-serif text-lg text-rose-900 italic font-medium m-0" data-id="element-116">
                  "This isn't your fault. You didn't break your skin. The
                  products did."
                </p>
              </div>

              <h2 className="font-sans font-bold text-2xl md:text-3xl text-slate-900 mt-12 mb-6" data-id="element-117">
                Why "Gentle" Products Still Burn Your Face
              </h2>

              <p data-id="element-118">Here's the thing most people don't realize.</p>

              <p data-id="element-119">
                CeraVe, Vanicream, even the expensive "clean beauty"
                brands—they're all made from the same stuff.
              </p>

              <p data-id="element-120">Look at the ingredients:</p>

              <ul className="not-prose space-y-4 my-6" data-id="element-121">
                <li className="flex gap-3" data-id="element-122">
                  <X className="text-red-500 flex-shrink-0 mt-1" data-id="element-123" />
                  <span className="text-slate-700" data-id="element-124">
                    Plant-based oils your skin doesn't recognize
                  </span>
                </li>
                <li className="flex gap-3" data-id="element-125">
                  <X className="text-red-500 flex-shrink-0 mt-1" data-id="element-126" />
                  <span className="text-slate-700" data-id="element-127">
                    Synthetic emulsifiers that act like detergent
                  </span>
                </li>
                <li className="flex gap-3" data-id="element-128">
                  <X className="text-red-500 flex-shrink-0 mt-1" data-id="element-129" />
                  <span className="text-slate-700" data-id="element-130">
                    Petroleum derivatives that sit on top of your skin like
                    plastic wrap
                  </span>
                </li>
              </ul>

              <p data-id="element-131">Your skin doesn't recognize any of it.</p>

              <p data-id="element-132">So it attacks. Every single time.</p>

              <p data-id="element-133">
                That's why switching from one "hypoallergenic" brand to another
                doesn't help.
              </p>

              <p className="font-bold text-slate-900" data-id="element-134">
                They're all foreign invaders in different packaging.
              </p>

              <p data-id="element-135">
                It's also why water-based serums don't work for reactive skin.
                Your skin barrier is made of oil, not water. Water-based
                products can't get through. They sit on top and evaporate. This
                leaves your skin even drier than before.
              </p>

              <p data-id="element-136">The cycle continues.</p>

              <p data-id="element-137">
                You try something new. It burns. You try something else. It
                burns too.
              </p>

              <p data-id="element-138">Your skin gets more reactive with each failure.</p>

              <p data-id="element-139">Until you feel like nothing will ever work.</p>

              <h2 className="font-sans font-bold text-2xl md:text-3xl text-slate-900 mt-12 mb-6" data-id="element-140">
                What Your Skin Actually Recognizes as "Safe"
              </h2>

              <p data-id="element-141">There's only ONE type of fat your skin doesn't attack.</p>

              <p data-id="element-142">The kind it makes itself.</p>

              <p data-id="element-143">It's called sebum. Your skin's natural oil.</p>

              <img src="https://cdn.magicpatterns.com/uploads/m4mEmBWgfNsArXLVwPfQ4A/ChatGPT_Image_28_Ιαν_2026,_04_10_33_μ.μ..png" alt="Close-up of healthy, calm skin with natural glow" className="w-full rounded-xl my-8 shadow-lg" data-id="element-144" />

              <p data-id="element-145">
                Your body has been making sebum for 200,000 years. It knows
                exactly what sebum looks like. What it feels like. How it
                behaves.
              </p>

              <p data-id="element-146">
                When sebum touches your skin, there's no alarm. No attack. No
                burning.
              </p>

              <p data-id="element-147">Your skin says: "Oh, this is mine. This is safe."</p>

              <p data-id="element-148">Now here's where it gets interesting.</p>

              <p data-id="element-149">
                Scientists discovered that grass-fed beef tallow has almost the
                exact same structure as human sebum.
              </p>

              <p data-id="element-150">
                The same fatty acids. The same ratios. The same molecular shape.
              </p>

              <p data-id="element-151">
                Your great-grandmother knew this. Before 1960, tallow was what
                families used to heal cracked, dry, irritated skin. It worked
                for thousands of years.
              </p>

              <p data-id="element-152">
                Then the petroleum industry came along. Synthetic lotions were
                cheaper to make. Tallow got pushed aside and forgotten.
              </p>

              <p data-id="element-153">But your skin never forgot what it needs.</p>

              <div className="bg-rose-50 border-l-4 border-rose-500 p-6 my-8 not-prose rounded-r-lg" data-id="element-154">
                <p className="font-serif text-lg text-rose-900 italic font-medium m-0" data-id="element-155">
                  "When you give your skin something it recognizes as 'self'
                  instead of 'enemy,' everything changes. The attack stops. The
                  burning stops. The redness calms."
                </p>
              </div>

              <p data-id="element-156">Your skin's immune system finally stands down.</p>

              <h2 className="font-sans font-bold text-2xl md:text-3xl text-slate-900 mt-12 mb-6" data-id="element-157">
                A Small Company Did What Big Skincare Wouldn't
              </h2>

              <p data-id="element-158">Most big skincare brands won't touch tallow.</p>

              <p data-id="element-159">
                It's harder to source. It costs more. And it doesn't fit the
                "clean beauty" marketing that sells products.
              </p>

              <p data-id="element-160">
                But a small team of formulators understood the science. They
                knew why reactive skin keeps reacting. And they created
                something different.
              </p>

              <img src="https://cdn.magicpatterns.com/uploads/rMVnf889V7ZvmefMt19dzE/ChatGPT_Image_28_Ιαν_2026,_04_10_30_μ.μ..png" alt="Woman applying Glisera CalmShield Balm with peaceful expression" className="w-full rounded-xl my-8 shadow-lg" data-id="element-161" />

              <p className="font-bold text-slate-900 text-xl" data-id="element-162">
                It's called Glisera™ CalmShield Balm.
              </p>

              <p data-id="element-163">
                This is a whipped tallow balm made from 100% grass-fed,
                grass-finished beef fat.
              </p>

              <p data-id="element-164">It's structured to match your skin's own sebum.</p>

              <p data-id="element-165">Here's what's inside:</p>

              <div className="bg-slate-50 rounded-xl p-6 my-8 not-prose" data-id="element-166">
                <ul className="space-y-3" data-id="element-167">
                  <li className="flex items-start gap-3" data-id="element-168">
                    <div className="bg-rose-500 rounded-full p-1 mt-0.5" data-id="element-169">
                      <Check size={12} className="text-white" strokeWidth={3} data-id="element-170" />
                    </div>
                    <div data-id="element-171">
                      <span className="text-slate-900 font-bold block" data-id="element-172">
                        Grass-fed tallow
                      </span>
                      <span className="text-slate-600 text-sm" data-id="element-173">
                        The foundation. Bio-identical to your skin's natural
                        oil. Your body recognizes it as "self."
                      </span>
                    </div>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-174">
                    <div className="bg-rose-500 rounded-full p-1 mt-0.5" data-id="element-175">
                      <Check size={12} className="text-white" strokeWidth={3} data-id="element-176" />
                    </div>
                    <div data-id="element-177">
                      <span className="text-slate-900 font-bold block" data-id="element-178">
                        Raw honey
                      </span>
                      <span className="text-slate-600 text-sm" data-id="element-179">
                        Soothes irritated skin. Supports your skin's natural
                        protective barrier.
                      </span>
                    </div>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-180">
                    <div className="bg-rose-500 rounded-full p-1 mt-0.5" data-id="element-181">
                      <Check size={12} className="text-white" strokeWidth={3} data-id="element-182" />
                    </div>
                    <div data-id="element-183">
                      <span className="text-slate-900 font-bold block" data-id="element-184">
                        GHK-Cu peptide
                      </span>
                      <span className="text-slate-600 text-sm" data-id="element-185">
                        A copper peptide that occurs naturally in your blood.
                        Helps your skin rebuild and repair itself.
                      </span>
                    </div>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-186">
                    <div className="bg-rose-500 rounded-full p-1 mt-0.5" data-id="element-187">
                      <Check size={12} className="text-white" strokeWidth={3} data-id="element-188" />
                    </div>
                    <div data-id="element-189">
                      <span className="text-slate-900 font-bold block" data-id="element-190">
                        Methylene blue
                      </span>
                      <span className="text-slate-600 text-sm" data-id="element-191">
                        Supports your skin cells' energy production. Helps
                        tired, damaged skin recover faster.
                      </span>
                    </div>
                  </li>
                </ul>
              </div>

              <p data-id="element-192">And here's what's NOT inside:</p>

              <div className="bg-white border-2 border-red-100 rounded-lg p-4 my-6 not-prose" data-id="element-193">
                <div className="grid grid-cols-2 md:grid-cols-3 gap-3 text-sm text-slate-700" data-id="element-194">
                  <div className="flex items-center gap-2" data-id="element-195">
                    <X size={16} className="text-red-500 flex-shrink-0" data-id="element-196" />
                    <span data-id="element-197">No seed oils</span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-198">
                    <X size={16} className="text-red-500 flex-shrink-0" data-id="element-199" />
                    <span data-id="element-200">No petroleum</span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-201">
                    <X size={16} className="text-red-500 flex-shrink-0" data-id="element-202" />
                    <span data-id="element-203">No synthetic emulsifiers</span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-204">
                    <X size={16} className="text-red-500 flex-shrink-0" data-id="element-205" />
                    <span data-id="element-206">No fragrance</span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-207">
                    <X size={16} className="text-red-500 flex-shrink-0" data-id="element-208" />
                    <span data-id="element-209">No niacinamide</span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-210">
                    <X size={16} className="text-red-500 flex-shrink-0" data-id="element-211" />
                    <span data-id="element-212">No parabens</span>
                  </div>
                </div>
              </div>

              <p data-id="element-213">Nothing your skin will see as a threat.</p>

              <p data-id="element-214">Just ingredients your body already knows.</p>

              <h2 className="font-sans font-bold text-2xl md:text-3xl text-slate-900 mt-12 mb-6" data-id="element-215">
                Women Who Thought Nothing Would Work Are Finally Getting Relief
              </h2>

              <img src="https://cdn.magicpatterns.com/uploads/jcA39qq8AYX5gX2DTzjkoX/ChatGPT_Image_28_Ιαν_2026,_04_16_40_μ.μ..png" alt="Happy woman with calm, healthy skin smiling" className="w-full rounded-xl my-8 shadow-lg" data-id="element-216" />

              <div className="not-prose grid gap-6 my-8" data-id="element-217">
                <TestimonialCard headline="I almost cried the first time I used it" quote="I've tried everything. CeraVe made me break out. Vanicream still burned. Protopic felt like fire on my face. This is the first thing my skin has tolerated in 3 years. I put it on my eyelids—the most sensitive part of my face—and nothing burned. I almost cried." author="Sarah M." location="Phoenix, AZ" avatarUrl="https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=100&h=100&q=80" data-id="element-218" />
                <TestimonialCard headline="Water finally feels like water again" quote="After years of topical steroids, my face burned every time I washed it. Even plain water felt like acid. I was scared to try anything new. But CalmShield didn't burn. Not even a little. After two weeks, I noticed my face wasn't as red. After a month, I could wash my face without bracing myself." author="Diana R." location="Austin, TX" avatarUrl="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=100&h=100&q=80" data-id="element-219" />
                <TestimonialCard headline="I can look in the mirror without dreading what I'll see" quote="My rosacea made me avoid mirrors. I hated seeing the redness, the bumps, the angry skin staring back at me. I've used CalmShield for six weeks now. My skin is calmer. Less red. Less reactive. I don't have perfect skin. But I have MY skin back. And I can finally look at it without feeling ashamed." author="Jennifer K." location="Denver, CO" avatarUrl="https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?auto=format&fit=crop&w=100&h=100&q=80" data-id="element-220" />
              </div>

              <h2 className="font-sans font-bold text-2xl md:text-3xl text-slate-900 mt-12 mb-6" data-id="element-221">
                What Happens When Your Skin Finally Gets What It Needs
              </h2>

              <p data-id="element-222">Using CalmShield is simple.</p>

              <p data-id="element-223">
                A small amount goes a long way. Just warm a pea-sized amount
                between your fingers and press it gently into clean skin.
              </p>

              <p data-id="element-224">What might you feel?</p>

              <p data-id="element-225">
                Some women notice calm skin right away. The burning they
                expected never comes. Their face just... absorbs it.
              </p>

              <p data-id="element-226">
                Others take a few days. Everyone's skin barrier is different.
                Years of damage take time to heal.
              </p>

              <p data-id="element-227">
                If you feel a slight tingle at first, that's okay. A tingle is
                not the same as burning. It usually fades by day two or three as
                your skin adjusts.
              </p>

              <p data-id="element-228">With regular use, many women notice something bigger.</p>

              <p data-id="element-229">
                Their skin gets less reactive overall. Less red. Less angry.
                Fewer flare-ups.
              </p>

              <p data-id="element-230">
                They stop fearing their skincare routine. They stop dreading the
                mirror.
              </p>

              <p className="font-bold text-slate-900" data-id="element-231">
                Their skin feels like theirs again.
              </p>

              <h2 className="font-sans font-bold text-2xl md:text-3xl text-slate-900 mt-12 mb-6" data-id="element-232">
                Try It Without Risk
              </h2>

              <p data-id="element-233">We know you've been burned before.</p>

              <p data-id="element-234">Literally.</p>

              <p data-id="element-235">
                We know you're scared to try something new. Every product feels
                like a gamble. Another chance to make things worse.
              </p>

              <p data-id="element-236">So we made this easy.</p>

              <div className="bg-slate-100 p-6 rounded-lg my-8 not-prose" data-id="element-237">
                <h4 className="font-bold text-slate-900 mb-2" data-id="element-238">
                  Our 60-Day "Empty Jar" Guarantee
                </h4>
                <p className="text-slate-700 mb-4" data-id="element-239">
                  If CalmShield doesn't work for you, just reach out. You'll get
                  a full refund. No questions asked. No hoops to jump through.
                  No guilt.
                </p>
                <div className="flex items-center gap-2 text-rose-700 font-bold text-sm" data-id="element-240">
                  <ShieldCheck size={20} data-id="element-241" />
                  <span data-id="element-242">Risk-Free Trial</span>
                </div>
              </div>

              <p data-id="element-243">
                We believe in this product because we've seen what it does. But
                we also know your skin has been through a lot. We want you to
                feel safe trying it.
              </p>

              <p data-id="element-244">Right now, readers can save 30% on their first order.</p>

              <p data-id="element-245">
                We make CalmShield in small batches to keep quality high. We
                source our tallow from grass-fed, grass-finished farms. This
                means we sometimes run low on stock.
              </p>

              <p data-id="element-246">If you've read this far, something here spoke to you.</p>

              <p data-id="element-247">
                Maybe you're tired of burning. Tired of guessing. Tired of
                products that promise "gentle" and deliver pain.
              </p>

              <p data-id="element-248">Maybe you're ready for something different.</p>

              <h2 className="font-sans font-bold text-2xl md:text-3xl text-slate-900 mt-12 mb-6" data-id="element-249">
                Quick Answers To Common Questions
              </h2>

              <div className="not-prose space-y-2 mb-12" data-id="element-250">
                <FAQItem question="How long before I see results?" answer="Most women report noticing changes within 2-3 weeks. Some see improvements in skin comfort within the first few days. Others notice calmer, less reactive skin around week 3-4. Remember, you're rebuilding your skin barrier after months or years of damage. It takes time for your skin to heal." data-id="element-251" />
                <FAQItem question="Can I use this with prescription treatments?" answer="CalmShield is a topical skincare product, but if you're using prescription treatments (like topical steroids, retinoids, or other medications), please check with your dermatologist before adding any new product to your routine." data-id="element-252" />
                <FAQItem question="Will this clog my pores?" answer="Tallow is non-comedogenic and has a similar structure to your skin's natural sebum, which means it absorbs well without clogging pores. However, everyone's skin is different. If you're prone to acne, start with a small amount on a test area first." data-id="element-253" />
                <FAQItem question="How much should I use?" answer="A little goes a long way. Start with a pea-sized amount for your entire face. Warm it between your fingers and press gently into clean skin. You can use it morning and night, or just at night if you prefer." data-id="element-254" />
                <FAQItem question="Does it have a smell?" answer="CalmShield has a very mild, natural scent from the raw honey. There's no added fragrance. Most users say it has a subtle, clean smell that fades quickly after application." data-id="element-255" />
                <FAQItem question="What if I have food allergies?" answer="CalmShield contains beef tallow and raw honey. If you have allergies to these ingredients, please do not use this product. The full ingredient list is available on our website." data-id="element-256" />
              </div>

              <div id="offer-section" className="bg-white border-2 border-[#6FA9C6] rounded-2xl p-6 md:p-10 shadow-2xl my-12 not-prose relative overflow-hidden" data-id="element-257">
                <div className="absolute top-0 right-0 bg-[#6FA9C6] text-white text-xs font-bold px-4 py-1 rounded-bl-lg" data-id="element-258">
                  LIMITED TIME OFFER
                </div>

                <h2 className="font-sans font-bold text-3xl text-slate-900 mb-2 text-center" data-id="element-259">
                  Your Skin Has Been Waiting for Something It Recognizes
                </h2>
                <p className="text-center text-slate-600 mb-8" data-id="element-260">
                  Save 30% on Glisera™ CalmShield Balm
                </p>

                <div className="flex justify-center mb-8" data-id="element-261">
                  <img src="https://cdn.magicpatterns.com/uploads/2tizk9mM9TfKNAY1VT9fiY/Ανωνυμο_σχεδιο_(66).png" alt="Glisera GHK-CU Whipped Tallow Honey Balm with Methylene Blue" className="w-48 md:w-64 h-auto object-contain" data-id="element-262" />
                </div>

                <div className="flex flex-col md:flex-row gap-8 items-center mb-8" data-id="element-263">
                  <div className="flex-1" data-id="element-264">
                    <ul className="space-y-3" data-id="element-265">
                      <li className="flex items-center gap-2 text-slate-700" data-id="element-266">
                        <Check size={20} className="text-[#6FA9C6]" data-id="element-267" />{' '}
                        Bio-Identical to Human Sebum
                      </li>
                      <li className="flex items-center gap-2 text-slate-700" data-id="element-268">
                        <Check size={20} className="text-[#6FA9C6]" data-id="element-269" /> Grass-Fed
                        Tallow Base
                      </li>
                      <li className="flex items-center gap-2 text-slate-700" data-id="element-270">
                        <Check size={20} className="text-[#6FA9C6]" data-id="element-271" /> 60-Day
                        Money-Back Guarantee
                      </li>
                      <li className="flex items-center gap-2 text-slate-700" data-id="element-272">
                        <Check size={20} className="text-[#6FA9C6]" data-id="element-273" /> No Seed
                        Oils or Synthetics
                      </li>
                      <li className="flex items-center gap-2 text-slate-700" data-id="element-274">
                        <Check size={20} className="text-[#6FA9C6]" data-id="element-275" /> Free
                        Shipping
                      </li>
                    </ul>
                  </div>

                  <div className="flex-1 w-full" data-id="element-276">
                    <Button fullWidth size="xl" onClick={scrollToOffer} className="mb-3 shadow-[#6FA9C6]/20 shadow-xl" data-id="element-277">
                      GET 30% OFF CALMSHIELD™ TODAY
                    </Button>
                    <div className="flex items-center justify-center gap-4 text-xs text-slate-500" data-id="element-278">
                      <span className="flex items-center gap-1" data-id="element-279">
                        <Truck size={12} data-id="element-280" /> Free Shipping
                      </span>
                      <span className="flex items-center gap-1" data-id="element-281">
                        <Clock size={12} data-id="element-282" /> Cancel Anytime
                      </span>
                    </div>
                  </div>
                </div>

                <p className="text-center text-sm text-slate-500 italic" data-id="element-283">
                  "No more burning. No more guessing. No more fear. Your skin
                  has been fighting foreign invaders for years. It's time to
                  give it something it knows."
                </p>
              </div>
            </article>
          </main>

          {/* Sticky Sidebar CTA - Desktop Only */}
          <aside className="hidden lg:block" data-id="element-284">
            <StickyCTA onCtaClick={scrollToOffer} data-id="element-285" />
          </aside>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-slate-50 border-t border-slate-200 py-12 px-4" data-id="element-286">
        <div className="max-w-3xl mx-auto text-center" data-id="element-287">
          <div className="mb-8" data-id="element-288">
            <div className="font-bold text-xl tracking-tight text-slate-900 mb-4" data-id="element-289">
              Glisera<span className="text-rose-600" data-id="element-290">™</span>
            </div>
            <p className="text-sm text-slate-500 max-w-lg mx-auto" data-id="element-291">
              Customer Support: gliserainfo@gmail.com
            </p>
          </div>

          <div className="text-[10px] text-slate-400 space-y-4 leading-relaxed border-t border-slate-200 pt-8" data-id="element-292">
            <p data-id="element-293">
              These statements have not been evaluated by the Food and Drug
              Administration. This product is not intended to diagnose, treat,
              cure, or prevent any disease. Results may vary. Individual results
              may vary, testimonials are not claimed to represent typical
              results.
            </p>
            <p data-id="element-294">
              This is an advertisement and not an actual news article, blog, or
              consumer protection update. Any photographs of persons used on
              this site are models.
            </p>
            <div className="flex justify-center gap-4 pt-4" data-id="element-295">
              <a href="#" className="hover:text-slate-600" data-id="element-296">
                Privacy Policy
              </a>
              <a href="#" className="hover:text-slate-600" data-id="element-297">
                Terms of Service
              </a>
              <a href="#" className="hover:text-slate-600" data-id="element-298">
                Ingredients
              </a>
            </div>
            <p className="pt-4" data-id="element-299">© 2025 Glisera. All rights reserved.</p>
          </div>
        </div>
      </footer>

      {/* Mobile Sticky CTA - Enhanced Version */}
      <div className={`fixed bottom-0 left-0 right-0 bg-white border-t-2 border-[#6FA9C6] shadow-[0_-8px_16px_-4px_rgba(0,0,0,0.15)] transition-transform duration-300 z-50 lg:hidden ${showStickyCTA ? 'translate-y-0' : 'translate-y-full'}`} data-id="element-300">
        <div className="p-4" data-id="element-301">
          <div className="flex items-center justify-between mb-3" data-id="element-302">
            <div data-id="element-303">
              <p className="font-bold text-sm text-slate-900" data-id="element-304">
                Calm Your Reactive Skin
              </p>
              <div className="flex items-center gap-1" data-id="element-305">
                {[...Array(5)].map((_, i) => <Star key={i} size={12} fill="#FCD34D" className="text-yellow-400" data-id="element-306" />)}
                <span className="text-xs text-slate-600 ml-1" data-id="element-307">4.9 (2,147)</span>
              </div>
            </div>
            <div className="bg-[#6FA9C6] text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-308">
              30% OFF
            </div>
          </div>
          <Button fullWidth onClick={scrollToOffer} size="lg" data-id="element-309">
            CHECK AVAILABILITY →
          </Button>
          <p className="text-[10px] text-center text-slate-500 mt-2" data-id="element-310">
            60-Day Guarantee • Free Shipping
          </p>
        </div>
      </div>
    </div>;
}